/* eslint-disable */
type GenericFunction = (...args: any[]) => any;

export const REJECT_MESSAGE = 'rejected due debouncing';
export const debounce = <
    F extends GenericFunction
>(func: F, waitFor: number): (...args: Parameters<F>) => Promise<ReturnType<F>> => {
    let timeout: any;
    let pendingPromiseReject: any;
    return (...args: Parameters<F>): Promise<ReturnType<F>> => new Promise((resolve, reject) => {
        if (waitFor === 0) {
            resolve(func(...args));
            return;
        }

        if (timeout) {
            pendingPromiseReject(new Error(REJECT_MESSAGE));
            clearTimeout(timeout);
        }
        pendingPromiseReject = reject;
        timeout = setTimeout(() => {
            timeout = null;
            pendingPromiseReject = null;
            resolve(func(...args));
        }, waitFor);
    });
};
